<template>
  <Transition name="tray">
    <div
      v-if="open"
      class="fixed inset-0 z-40 flex justify-end"
    >
      <div class="absolute inset-0 bg-black/30" @click="$emit('close')" />
      <div
        class="tray-panel relative bg-white shadow-xl flex flex-col overflow-hidden"
        :class="widthClass"
      >
        <slot />
      </div>
    </div>
  </Transition>
</template>

<script>
export default {
  name: 'SlideOverTray',
  props: {
    open: { type: Boolean, default: false },
    widthClass: { type: String, default: 'w-full max-w-xl' },
  },
  emits: ['close'],
  mounted() {
    document.addEventListener('keydown', this.onKeydown);
  },
  beforeUnmount() {
    document.removeEventListener('keydown', this.onKeydown);
  },
  methods: {
    onKeydown(e) {
      if (!this.open || e.key !== 'Escape' || e.defaultPrevented) return;
      e.stopPropagation();
      this.$emit('close');
    },
  },
};
</script>

<style scoped>
.tray-enter-active,
.tray-leave-active {
  transition: opacity 0.2s ease;
}
.tray-enter-active .tray-panel,
.tray-leave-active .tray-panel {
  transition: transform 0.2s ease;
}
.tray-enter-from,
.tray-leave-to {
  opacity: 0;
}
.tray-enter-from .tray-panel {
  transform: translateX(100%);
}
.tray-leave-to .tray-panel {
  transform: translateX(100%);
}
</style>
